import type { BasicTrip } from 'tripPlanner/types/common'
import { getCurrentIntl } from 'i18n/util/currentIntl'

export const getDefaultTripName = () => {
  const intl = getCurrentIntl()

  return intl.formatMessage({
    id: 'rB3COkek2AjnFKrTjZpB',
    defaultMessage: 'New Trip',
    description: 'Default fallback trip name used when a new trip has no destination-based title',
  })
}

export const getUniqueTripName = (
  original: string,
  trips: Array<BasicTrip>,
  maxLength: number,
  defaultName?: string,
): string => {
  const nextDefaultName = defaultName ?? getDefaultTripName()
  let num = 0
  const nonEmptyOriginal = original || nextDefaultName
  let proposed = prepareProposedTripName(maxLength, undefined, nonEmptyOriginal, nextDefaultName)

  const existingNames = new Set(trips.map((trip) => trip.name))
  while (existingNames.has(proposed)) {
    num++
    const suffix = ` (${num})`
    proposed = prepareProposedTripName(maxLength, suffix, nonEmptyOriginal, nextDefaultName)
  }

  return proposed.replace(/[\n\r]/g, ' ')
}

export const prepareProposedTripName = (
  maxLength: number,
  suffix?: string,
  original?: string,
  defaultName?: string,
) => {
  const nextDefaultName = defaultName ?? getDefaultTripName()
  if (original) {
    const additionalLength = suffix?.length || 0
    const trimmed = original.substring(0, maxLength - additionalLength - 1)
    return trimmed + (suffix ?? '')
  } else {
    return nextDefaultName
  }
}
